import type { WebWidgetModel } from '@web/types';

import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';
import { Widgets } from '@common/enums';

import { createIndent } from '@sites/entity-core';

import { IndentControlComponent } from '@web/widgets/indent/components/indent-control/indent-control.component';
import { IndentViewComponent } from '@web/widgets/indent/components/indent-view/indent-view.component';

/**
 * The spacer is a versioned widget: `createEntity` seeds a new one, and its
 * presence makes the editor lift persisted legacy spacers on load. There is
 * no legacy `data` / `styles` seed any more — everything lives in the entity's `props`.
 */
export const indentWidgetModel: WebWidgetModel = {
    componentView: IndentViewComponent,
    componentControl: IndentControlComponent,
    name: Widgets.INDENT,
    label: 'widget_spacer_label',
    data: undefined,
    permission: defaultWidgetPermission,
    params: defaultWidgetParams,
    signalForm: true,
    createEntity: createIndent,
};
